import React, { Component } from 'react'
import { get } from "lodash"

import {
  heightTypeData,
  getValidateCmMessage,
  getValidateFtMessage,
  checkIsValidFtHeight,
  checkIsValidCmHeight,
  checkIsChoosedHeightType,
  isFailureFtValidation,
  isFailureCmValidation,
} from "./static.heightData"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import ButtonFill from "../../../shared/items/controls/buttonFill"


class HeightNextStepButton extends Component {
  componentDidUpdate() {
    const { data } = this.props

    if (checkIsChoosedHeightType(data, heightTypeData.ft.value))
      this.checkvValidHeightFt()

    else if (checkIsChoosedHeightType(data, heightTypeData.cm.value))
      this.checkvValidHeightCm()
  }

  checkvValidHeightFt() {
    const { data, onSetFailValidate, onSetSuccessValidate } = this.props

    if (isFailureFtValidation(data))
      onSetFailValidate("height", getValidateFtMessage(get(data, ["height", "value"], null)))

    else if (checkIsValidFtHeight(data))
      onSetSuccessValidate("height")
  }

  checkvValidHeightCm() {
    const { data, onSetFailValidate, onSetSuccessValidate } = this.props

    if (isFailureCmValidation(data))
      onSetFailValidate("height", getValidateCmMessage(get(data, ["height", "value"], null)))

    else if (checkIsValidCmHeight(data))
      onSetSuccessValidate("height")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["height", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(HeightNextStepButton)